import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Forms from "./Forms";
import Users from "./Users";
import FormData from "./FormData";
import Spinner from "react-bootstrap/Spinner";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import GroupIcon from "@mui/icons-material/Group";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import DatasetIcon from "@mui/icons-material/Dataset";
import SettingsIcon from "@mui/icons-material/Settings";
import logo1 from "../images/ygLogoMailSignature.png";
import logo2 from "../images/yg_logo.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import DownloadHistory from "./DownloadHistory";
import DownloadingIcon from "@mui/icons-material/Downloading";
import YesFamily from "./YesFamily";
import dayjs from "dayjs";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { io } from "socket.io-client";
import { FunnelPlotOutlined } from "@ant-design/icons";
import InventoryIcon from "@mui/icons-material/Inventory";
import GroupsIcon from "@mui/icons-material/Groups";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Policies from "./Policies";
import Insights from "./Insights";
import Hierarchy from "./Hierarchy";
import Ticket from "./Tickets/Ticket";
import StudentMaster from "./StudentMaster";
import Mailer from "./Mailer";
import Settings from "./Settings";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import TAR from "./TAR";
import StudentFunnel from "./StudentFunnel";
import DepartmentKpi from "./DepartmentKpi";
import CustomSpinner from "../components/CustomSpinner";
import HomeIcon from "@mui/icons-material/Home";
import TicketDahboard from './dashboard/TicketDahboard'
import StudentMailer from "./dashboard/StudentMailer";
import DocumentDashboard from "./dashboard/document/DocumentDashboard";
import UniCatDash from "./dashboard/UniCatDash";
import MailConnectionStatus from "./dashboard/MailConnectionStatus";
import CvDashboard from './dashboard/cv/CvDashboard'
import ClDashboard from "./dashboard/courselist/ClDashboard";
import AutomationMonitor from "./AutomationMonitor";
import Consents from "./Consents";
import VisaDashboard from "./dashboard/visa/VisaDashboard";
import ApsDashboard from "./dashboard/aps/ApsDashboard";
import StudentReference from "./StudentReference";

function PageBinder({ serverURL }) {
  const socket = useRef(null);

  const [logToUse, setLogToUse] = useState(null);

  const [onlineUsers, setOnlineUsers] = useState([]);

  const [pageViews, setPageViews] = useState("Home");
  const [showSideOverlay, setShowSideOverlay] = useState(false);

  const [currentLogo, setCurrentLogo] = useState(logo2);
  const [activatedKey, setActivatedKey] = useState(0);

  const [loginView, setLoginView] = useState(true);
  const [user, setUser] = useState(null);

  const [allFormLogs, setAllFormLogs] = useState([]);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const logOut = async () => {
    document.cookie =
      "userTos=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "tokenTos=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    const logOut = await axios.get(serverURL + "/deleteCookie/" + user.email, {
      withCredentials: true,
    });
    if (logOut) {
      window.location.href = "/";
    }
  };

  const checkCookies = async () => {
    // ################### offline methods ###############################
    if (document.cookie && document.cookie.split(";").length > 1) {
      let globalUser = getCookie("userTos");
      let globalToken = getCookie("tokenTos");

      const checkValidCookies = await axios.post(
        serverURL + "/users/checkValidCookies",
        { email: globalUser, token: globalToken }
      );
      if (checkValidCookies.status === 200) {
        const findUser = await axios.post(serverURL + "/users/find", {
          token: globalToken,
        });
        if (findUser.status === 200) {
          setUser(findUser.data);
          setLoginView(true);
          socket.current.emit("addUser", globalUser);
        } else {
          console.log(findUser.data);
          setLoginView(true);
        }
      } else {
        console.log(checkValidCookies.data);
        window.location.href = "/";
      }
    } else {
      window.location.href = "/";
    }

    // ##################### Online Methods #################################
    // const getCookies = await axios.get(serverURL + "/getCookieUser", { withCredentials: true });
    // if (getCookies.status === 200) {
    //   let globalUser = getCookies.data.user;
    //   let globalToken = getCookies.data.token;

    //   const checkValidCookies = await axios.post(serverURL + "/users/checkValidCookies", { "email": globalUser, "token": globalToken })
    //   if (checkValidCookies.status === 200) {

    //     const findUser = await axios.post(serverURL + "/users/find", { token: globalToken })
    //     if (findUser.status === 200) {
    //       setUser(findUser.data)

    //       setLoginView(true)

    //     } else {
    //       console.log(findUser.data)
    //       setLoginView(true)
    //     }
    //   } else {
    //     console.log(checkValidCookies.data)
    //     window.location.href = "/"
    //   }
    // } else {
    //   console.log(getCookies.data)
    //   window.location.href = "/"
    // }
  };

  const getAllLogs = async () => {
    const getNow = await axios.post(serverURL + "/formLogs/getAllLogs");
    if (getNow.status === 200) {
      setAllFormLogs(getNow.data);
    } else {
      console.log(getNow.data);
    }
  };

  useEffect(() => {
    const availabelPaths = [
      "Home",
      "yesFamily",
      "hierarchy",
      "report-dashboard",
      "policies",
      "forms",
      "ticket",
      "ticketDashboard",
      "formData",
      "studentFunnel",
      "department",
      "visaDashboard",
      "apsDashboard",
      "cvDashboard",
      "cl-dashboard",
      "uniDashboard",
      "StudentConsent",
      "MailConnectionStatus",
      "tar",
      "settings",
      "mailer",
      "StudentMailer",
      "students",
      "studentReference",
      "users",
      "automonitor",
      "downloadHistory",
    ];

    const pathSection1 = ["yesFamily", "policies", "forms", "formData"]
    const pathSection2 = ["ticket", "ticketDashboard"]
    const pathSection3 = ["report-dashboard", "department", "visaDashboard", "apsDashboard", "cvDashboard", "cl-dashboard", "uniDashboard"]
    const pathSection4 = ["mailer", "StudentMailer", "MailConnectionStatus"]

    let path = window.location.href;

    let pathArray = path.split("/app");
    if (pathArray.length >= 2) {
      let takenPath = pathArray[1].split("/")[1]
      // console.log(takenPath);

      if (takenPath.includes("?")) {
        takenPath = takenPath.split("?")[0]
      }




      availabelPaths.map((path, key) => {
        if (takenPath?.includes(path)) {
          setPageViews(path);
        }
      })

      if (pathSection1.some((url) => { return takenPath?.includes(url) })) {
        setActivatedKey("0")
      } else if (pathSection2.some((url) => { return takenPath?.includes(url) })) {
        setActivatedKey("1")
      }
      else if (pathSection3.some((url) => { return takenPath?.includes(url) })) {
        setActivatedKey("2")
      }
      else if (pathSection4.some((url) => { return takenPath?.includes(url) })) {
        setActivatedKey("3")
      } else {
        setActivatedKey(null)
      }

    } else {
      setPageViews("Home");
    }

    const scoketIo = io(
      serverURL.includes("localhost")
        ? `ws://${serverURL.split("//")[1]}`
        : `wss://${serverURL.split("//")[1]}`
    );
    socket.current = scoketIo;

    scoketIo.on("getUsers", (users) => {
      if (users.length > 0) {
        // console.log(users)
        setOnlineUsers(users);
      }
    });
    scoketIo.emit("needOnlineUsers");

    getAllLogs();
    checkCookies();




    window.addEventListener("popstate", () => {

      console.log("changed hash")

      let path = window.location.href;

      let pathArray = path.split("app/");
      if (pathArray.length >= 2) {
        const takenPath = pathArray[1].split("/")[0]
        console.log(takenPath);

        if (availabelPaths.find((path) => { return path === takenPath })) {

          setPageViews(takenPath);

          if (pathSection1.includes(takenPath)) {
            setActivatedKey("0")
          } else if (pathSection2.includes(takenPath)) {
            setActivatedKey("1")
          }
          else if (pathSection3.includes(takenPath)) {
            setActivatedKey("2")
          }
          else if (pathSection4.includes(takenPath)) {
            setActivatedKey("3")
          } else {
            setActivatedKey(null)
          }
        } else {
          setPageViews("Home");
        }

      } else {
        setPageViews("Home");
      }

    })
  }, []);


  const setNewPath = (path) => {
    window.history.pushState(null, "", "/app/" + path);
  }



  return (
    <>
      {loginView && user ? (
        <div className="vh-100 w-100 overflow-hidden">
          <div className="h-100 d-flex">
            <div
              className="p-3 h-100 manueHoverExpandable d-none d-lg-flex align-items-start"
              style={{ maxWidth: "250px" }}
              onMouseEnter={() => {
                setCurrentLogo(logo1);
              }}
              onMouseLeave={() => {
                setCurrentLogo(logo2);
              }}
            >
              <div className="w-100 h-100 py-3 p-2 d-none d-lg-flex d-xl-flex d-xxl-flex flex-column rounded-5 shadow">
                <div
                  className="display-4 text-center text-light my-3"
                  style={{ fontFamily: "jokerman" }}
                >
                  <div
                    className="w-100"
                    style={{
                      transition: ".2s",
                      height: "80px",
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                      backgroundImage: `url(${currentLogo})`,
                    }}
                  ></div>
                </div>
                <div className="d-flex flex-column gap-1 h-100 manueBarMain">
                  {user.permissions.some((data) => data.value === "Home") ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "Home" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("Home");
                        setNewPath("Home")
                        setActivatedKey(null);
                      }}
                    >
                      <HomeIcon />
                      <span className="textToBeHiddenleftMenueButtons">
                        Home
                      </span>
                    </button>
                  ) : (
                    ""
                  )}


                  {user.permissions.some(
                    (data) => data.value === "Hierarchy-Tree"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "hierarchy" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("hierarchy");
                        setNewPath("hierarchy");
                        setActivatedKey(null);
                      }}
                    >
                      <AccountTreeIcon />
                      <span className="textToBeHiddenleftMenueButtons">
                        Hierarchy
                      </span>
                    </button>
                  ) : (
                    ""
                  )}


                  <Accordion
                    flush
                    className="no-bg-accordion"
                    activeKey={activatedKey}
                    onSelect={(e) => {
                      setActivatedKey(e);
                    }}
                  >
                    <Accordion.Item eventKey="0" as={"div"}>
                      <Accordion.Header as={"div"}>
                        <div className="d-flex align-items-center gap-1 additionalleftMenueButtons">
                          <GroupsIcon />
                          <span className="textToBeHiddenleftMenueButtons">
                            HR
                          </span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {user.permissions.some(
                          (data) => data.value === "Yes-Family"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "yesFamily" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("yesFamily");
                              setNewPath("yesFamily")
                            }}
                          >
                            <GroupsIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              Yes Family
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {user.permissions.some(
                          (data) => data.value === "Policies"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "policies" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("policies");
                              setNewPath("policies");
                            }}
                          >
                            <InventoryIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              Policies
                            </span>
                          </button>
                        ) : (
                          ""
                        )}
                        {user.permissions.some((data) => data.value === "Forms") ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "forms" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("forms");
                              setNewPath("forms");
                            }}
                          >
                            <DynamicFormIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              Forms
                            </span>
                          </button>
                        ) : (
                          ""
                        )}
                        {user.permissions.some(
                          (data) => data.value === "Form-Data"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "formData" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("formData");
                              setNewPath("formData");
                            }}
                          >
                            <DatasetIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              Form Data
                            </span>
                          </button>
                        ) : (
                          ""
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  {user.permissions.some((data) => data.value === "Tickets") ? (
                    <Accordion
                      flush
                      className="no-bg-accordion"
                      activeKey={activatedKey}
                      onSelect={(e) => {
                        setActivatedKey(e);
                      }}
                    >
                      <Accordion.Item eventKey="1" as={"div"}>
                        <Accordion.Header as={"div"}>
                          <div className="d-flex align-items-center gap-1 additionalleftMenueButtons">
                            <AddTaskIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              Ticket
                            </span>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {user.permissions.some(
                            (data) => data.value === "Tickets-Dashboard"
                          ) ? (
                            <button
                              className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "ticketDashboard" ? "active" : ""
                                }`}
                              onClick={(e) => {
                                setNewPath("ticketDashboard")
                                setPageViews("ticketDashboard");
                              }}
                            >
                              <SettingsIcon />
                              <span className="textToBeHiddenleftMenueButtons text-nowrap">
                                Ticket Dashboard
                              </span>
                            </button>
                          ) : (
                            ""
                          )}
                          {user.permissions.some(
                            (data) => data.value === "Tickets"
                          ) ? (
                            <button
                              className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "ticket" ? "active" : ""
                                }`}
                              onClick={(e) => {
                                setPageViews("ticket");
                                setNewPath("ticket");
                                setLogToUse(null);
                              }}
                            >
                              <AddTaskIcon />
                              <span className="textToBeHiddenleftMenueButtons">
                                Ticket
                              </span>
                            </button>
                          ) : (
                            ""
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ) : (
                    ""
                  )}

                  {user.permissions.some(
                    (data) => data.value === "Ticket-Assignment-Rule"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "tar" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("tar");
                        setNewPath("tar");
                        setActivatedKey(null);
                      }}
                    >
                      <AutoModeIcon />
                      <span className="textToBeHiddenleftMenueButtons">
                        TAR
                      </span>
                    </button>
                  ) : (
                    ""
                  )}

                  {user.permissions.some(
                    (data) => data.value === "Student-Consent"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "StudentConsent" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("StudentConsent");
                        setNewPath("StudentConsent");
                        setActivatedKey(null);
                      }}
                    >
                      <AutoModeIcon />
                      <span className="textToBeHiddenleftMenueButtons">
                        Student Consents
                      </span>
                    </button>
                  ) : (
                    ""
                  )}


                  {user.permissions.some(
                    (data) => data.value === "Student-Funnel"
                  ) ? (
                    <button
                      className={`leftMenueButtons mb-1 w-100 d-flex align-items-center gap-1 ${pageViews === "studentFunnel" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("studentFunnel");
                        setNewPath("studentFunnel");
                        setActivatedKey(null)
                      }}
                    >
                      <FunnelPlotOutlined style={{ fontSize: "23px" }} />
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Student Funnel
                      </span>
                    </button>
                  ) : (
                    ""
                  )}

                  <Accordion
                    flush
                    className="no-bg-accordion"
                    activeKey={activatedKey}
                    onSelect={(e) => {
                      setActivatedKey(e);
                    }}
                  >
                    <Accordion.Item eventKey="2" as={"div"}>
                      <Accordion.Header as={"div"}>
                        <div className="d-flex align-items-center gap-1 additionalleftMenueButtons">
                          <SettingsIcon />
                          <span className="textToBeHiddenleftMenueButtons">
                            Dashboards
                          </span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>

                        {user.permissions.some(
                          (data) => data.value === "Document-Dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "report-dashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("report-dashboard");
                              setNewPath("report-dashboard");
                            }}
                          >
                            <AccountTreeIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              Document
                            </span>
                          </button>
                        ) : (
                          ""
                        )}


                        {user.permissions.some(
                          (data) => data.value === "Department-KPI"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "department" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("department");
                              setNewPath("department");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              Accounts
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {user.permissions.some(
                          (data) => data.value === "Visa-Dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "visaDashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("visaDashboard");
                              setNewPath("visaDashboard");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              Visa
                            </span>
                          </button>
                        ) : (
                          ""
                        )}
                        {user.permissions.some(
                          (data) => data.value === "aps-Dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "apsDashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("apsDashboard");
                              setNewPath("apsDashboard");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons">
                              APS
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {user.permissions.some(
                          (data) => data.value === "CL-Dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "cl-dashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("cl-dashboard");
                              setNewPath("cl-dashboard");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              CL
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {user.permissions.some(
                          (data) => data.value === "CV-Dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "cvDashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("cvDashboard");
                              setNewPath("cvDashboard");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              CV/SOP
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {user.permissions.some(
                          (data) => data.value === "university-dashboard"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "uniDashboard" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("uniDashboard");
                              setNewPath("uniDashboard");
                            }}
                          >
                            <SettingsIcon />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              University
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>


                  <Accordion
                    flush
                    className="no-bg-accordion"
                    activeKey={activatedKey}
                    onSelect={(e) => {
                      setActivatedKey(e);
                    }}
                  >
                    <Accordion.Item eventKey="3" as={"div"}>
                      <Accordion.Header as={"div"}>
                        <div className="d-flex align-items-center gap-1 additionalleftMenueButtons">
                          <i className="fa fa-envelope mx-1" />
                          <span className="textToBeHiddenleftMenueButtons text-nowrap">
                            Student Mails
                          </span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {user.permissions.some(
                          (data) => data.value === "Student-Mail"
                        ) ? (
                          <button
                            className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "mailer" ? "active" : ""
                              }`}
                            onClick={(e) => {
                              setPageViews("mailer");
                              setNewPath("mailer");
                            }}
                          >
                            <i className="fa fa-envelope mx-1" />
                            <span className="textToBeHiddenleftMenueButtons text-nowrap">
                              Student Mails
                            </span>
                          </button>
                        ) : (
                          ""
                        )}

                        {
                          user.permissions.some((data) => data.value === "YG-Mail-Dashboard") ? (
                            <button
                              className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "StudentMailer" ? "active" : ""
                                }`}
                              onClick={(e) => {
                                setPageViews("StudentMailer");
                                setNewPath("StudentMailer");
                              }}
                            >
                              <i className="fa fa-envelope mx-1" />
                              <span className="textToBeHiddenleftMenueButtons text-nowrap">
                                YG Mail Dashboard
                              </span>
                            </button>
                          )
                            :
                            ""
                        }
                        {
                          user.permissions.some((data) => data.value === "Mail-Connection-Status") ? (
                            <button
                              className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "MailConnectionStatus" ? "active" : ""
                                }`}
                              onClick={(e) => {
                                setPageViews("MailConnectionStatus");
                                setNewPath("MailConnectionStatus");
                              }}
                            >
                              <i className="fa fa-envelope mx-1" />
                              <span className="textToBeHiddenleftMenueButtons text-nowrap">
                                Mail Status
                              </span>
                            </button>
                          )
                            :
                            ""
                        }
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  {user.permissions.some(
                    (data) => data.value === "Student-Master"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "students" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("students");
                        setNewPath("students");
                        setActivatedKey(null);
                      }}
                    >
                      <i className="fa-duotone fa-solid fa-graduation-cap"></i>
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Students
                      </span>
                    </button>
                  ) : (
                    ""
                  )}

                  {user.permissions.some(
                    (data) => data.value === "Student-Reference-View"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "studentReference" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("studentReference");
                        setNewPath("studentReference");
                        setActivatedKey(null);
                      }}
                    >
                      <i className="fa-duotone fa-solid fa-graduation-cap"></i>
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Student Reference
                      </span>
                    </button>
                  ) : (
                    ""
                  )}

                  {user.userType === "admin" ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "users" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("users");
                        setNewPath("users");
                        setActivatedKey(null);
                      }}
                    >
                      <GroupIcon />
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Users
                      </span>
                    </button>
                  ) : (
                    ""
                  )}

                  {user.userType === "admin" || user.permissions.some(
                    (data) => data.value === "Automation-Monitor"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "automonitor" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("automonitor");
                        setNewPath("automonitor");
                        setActivatedKey(null);
                      }}
                    >
                      <AutoAwesomeIcon />
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Automation Monitor
                      </span>
                    </button>
                  ) : (
                    ""
                  )}


                  {user.permissions.some(
                    (data) => data.value === "Download-History"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "downloadHistory" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("downloadHistory");
                        setNewPath("downloadHistory");
                        setActivatedKey(null);
                      }}
                    >
                      <DownloadingIcon />
                      <span className="textToBeHiddenleftMenueButtons">
                        Download History
                      </span>
                    </button>
                  ) : (
                    ""
                  )}
                  {user.permissions.some(
                    (data) => data.value === "Settings"
                  ) ? (
                    <button
                      className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "settings" ? "active" : ""
                        }`}
                      onClick={(e) => {
                        setPageViews("settings");
                        setNewPath("settings");
                        setActivatedKey(null);
                      }}
                    >
                      <SettingsIcon />
                      <span className="textToBeHiddenleftMenueButtons text-nowrap">
                        Settings
                      </span>
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    className={`leftMenueButtons logOutButton w-100 d-flex align-items-center gap-1`}
                    onClick={(e) => {
                      logOut();
                    }}
                  >
                    <PowerSettingsNewIcon />
                    <span className="textToBeHiddenleftMenueButtons text-nowrap">
                      Log Out
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="h-100 w-100 overflow-auto d-flex flex-column p-3">
              {pageViews === "Home" ? (
                <Insights
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "yesFamily" ? (
                <YesFamily
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "hierarchy" ? (
                <Hierarchy
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "policies" ? (
                <Policies
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "report-dashboard" ? (
                <DocumentDashboard
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "formData" ? (
                <FormData
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "forms" ? (
                <Forms
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                />
              ) : pageViews === "ticket" ? (
                <Ticket
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                  logToUse={logToUse}
                  setLogToUse={setLogToUse}
                />
              ) : pageViews === "ticketDashboard" ? (
                <TicketDahboard
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                  logToUse={logToUse}
                  setLogToUse={setLogToUse}
                />
              ) : pageViews === "mailer" ? (
                <Mailer
                  serverURL={serverURL}
                  user={user}
                  setShowSideOverlay={setShowSideOverlay}
                  socket={socket.current}
                  onlineUsers={onlineUsers}
                  logToUse={logToUse}
                  setLogToUse={setLogToUse}
                />
              )
                : pageViews === "StudentMailer" ? (
                  <StudentMailer
                    serverURL={serverURL}
                    user={user}
                    setShowSideOverlay={setShowSideOverlay}
                    socket={socket.current}
                    onlineUsers={onlineUsers}
                    logToUse={logToUse}
                    setLogToUse={setLogToUse}
                    setPageViews={setPageViews}
                    setNewPath={setNewPath}
                  />
                )
                  : pageViews === "MailConnectionStatus" ? (
                    <MailConnectionStatus
                      serverURL={serverURL}
                      user={user}
                      setShowSideOverlay={setShowSideOverlay}
                      socket={socket.current}
                      onlineUsers={onlineUsers}
                      logToUse={logToUse}
                      setLogToUse={setLogToUse}
                      setPageViews={setPageViews}
                      setNewPath={setNewPath}
                    />
                  )
                    : pageViews === "users" ? (
                      <Users
                        serverURL={serverURL}
                        user={user}
                        setUser={setUser}
                        setShowSideOverlay={setShowSideOverlay}
                        socket={socket.current}
                        onlineUsers={onlineUsers}
                      />
                    )
                      : pageViews === "automonitor" ? (
                        <AutomationMonitor
                          serverURL={serverURL}
                          user={user}
                          setUser={setUser}
                          setShowSideOverlay={setShowSideOverlay}
                          socket={socket.current}
                          onlineUsers={onlineUsers}
                        />
                      )
                        : pageViews === "tar" ? (
                          <TAR
                            serverURL={serverURL}
                            user={user}
                            setUser={setUser}
                            setShowSideOverlay={setShowSideOverlay}
                            socket={socket.current}
                            onlineUsers={onlineUsers}
                          />
                        ) :
                          pageViews === "StudentConsent" ? (
                            <Consents
                              serverURL={serverURL}
                              user={user}
                              setUser={setUser}
                              setShowSideOverlay={setShowSideOverlay}
                              socket={socket.current}
                              onlineUsers={onlineUsers}
                            />
                          )
                            : pageViews === "students" ? (
                              <StudentMaster
                                serverURL={serverURL}
                                user={user}
                                setUser={setUser}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ):
                            pageViews === "studentReference" ? (
                                <StudentReference
                                  serverURL={serverURL}
                                  user={user}
                                  setUser={setUser}
                                  setShowSideOverlay={setShowSideOverlay}
                                  socket={socket.current}
                                  onlineUsers={onlineUsers}
                                />
                              ) 
                            
                            : pageViews === "studentFunnel" ? (
                              <StudentFunnel
                                serverURL={serverURL}
                                user={user}
                                setUser={setUser}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "settings" ? (
                              <Settings
                                serverURL={serverURL}
                                user={user}
                                setUser={setUser}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "downloadHistory" ? (
                              <DownloadHistory
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "department" ? (
                              <DepartmentKpi
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "visaDashboard" ? (
                              <VisaDashboard
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "apsDashboard" ? (
                              <ApsDashboard
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "cl-dashboard" ? (
                              <ClDashboard
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "cvDashboard" ? (
                              <CvDashboard
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : pageViews === "uniDashboard" ? (
                              <UniCatDash
                                serverURL={serverURL}
                                user={user}
                                setShowSideOverlay={setShowSideOverlay}
                                socket={socket.current}
                                onlineUsers={onlineUsers}
                              />
                            ) : (
                              ""
                            )}
            </div>
          </div>
        </div>
      ) : (
        <div className="vh-100 w-100 d-flex align-items-center justify-content-center">
          <CustomSpinner size={1} />
        </div>
      )}

      <Offcanvas
        show={showSideOverlay}
        onHide={() => {
          setShowSideOverlay(false);
        }}
        className="customBackground"
      >
        <Offcanvas.Header closeButton className="d-flex align-items-start">
          <Offcanvas.Title>
            <img
              src={logo1}
              className="w-100 "
              style={{
                maxWidth: "130px",
                filter: "drop-shadow(0 0 1px white)",
              }}
              alt=""
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {user ? (
            <div className="d-flex flex-column gap-1">
              {user.permissions.some((data) => data.value === "Home") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "Home" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("Home");
                    setShowSideOverlay(false);
                    setNewPath("Home");
                  }}
                >
                  <HomeIcon />
                  Home
                </button>
              ) : (
                ""
              )}

              {user.permissions.some((data) => data.value === "Yes-Family") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "yesFamily" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("yesFamily");
                    setShowSideOverlay(false);
                    setNewPath("yesFamily");
                  }}
                >
                  <GroupsIcon />
                  Yes Family
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Hierarchy-Tree"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "hierarchy" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("hierarchy");
                    setNewPath("hierarchy");
                    setShowSideOverlay(false);
                  }}
                >
                  <AccountTreeIcon />
                  Hierarchy
                </button>
              ) : (
                ""
              )}

              {user.permissions.some((data) => data.value === "Policies") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "policies" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("policies");
                    setNewPath("policies");
                    setShowSideOverlay(false);
                  }}
                >
                  <InventoryIcon />
                  Policies
                </button>
              ) : (
                ""
              )}

              {user.permissions.some((data) => data.value === "Forms") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "forms" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("forms");
                    setNewPath("forms");
                    setShowSideOverlay(false);
                  }}
                >
                  <DynamicFormIcon />
                  Forms
                </button>
              ) : (
                ""
              )}
              {user.permissions.some((data) => data.value === "Form-Data") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "formData" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("formData");
                    setNewPath("formData");
                    setShowSideOverlay(false);
                  }}
                >
                  <DatasetIcon />
                  Form Data
                </button>
              ) : (
                ""
              )}

              {user.permissions.some((data) => data.value === "Tickets") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "ticket" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("ticket");
                    setNewPath("ticket");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  Ticket
                </button>
              ) : (
                ""
              )}
              {user.permissions.some(
                (data) => data.value === "Ticket-Assignment-Rule"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "tar" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("tar");
                    setNewPath("tar");
                    setShowSideOverlay(false);
                  }}
                >
                  <AutoModeIcon />
                  TAR
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Department-KPI"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "department" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("department");
                    setNewPath("department");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  Department
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Visa-Dashboard"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "visaDashboard" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("visaDashboard");
                    setNewPath("visaDashboard");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  Visa Dashboard
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "aps-Dashboard"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "apsDashboard" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("apsDashboard");
                    setNewPath("apsDashboard");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  APS Dashboard
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "CV-Dashboard"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "cvDashboard" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("cvDashboard");
                    setNewPath("cvDashboard");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  CV Dashboard
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Mail-Connection-Status"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "MailConnectionStatus" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("MailConnectionStatus");
                    setNewPath("MailConnectionStatus");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  Mail Status
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "university-dashboard"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "uniDashboard" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("uniDashboard");
                    setNewPath("uniDashboard");
                    setShowSideOverlay(false);
                    setLogToUse(null);
                  }}
                >
                  <AddTaskIcon />
                  University Dashboard
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Student-Funnel"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "studentFunnel" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("studentFunnel");
                    setNewPath("studentFunnel");
                    setShowSideOverlay(false);
                  }}
                >
                  <DatasetIcon />
                  Student Funnel
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Student-Mail"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "mailer" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("mailer");
                    setNewPath("mailer");
                    setShowSideOverlay(false);
                  }}
                >
                  <i className="fa fa-envelope mx-1" /> Student Mails
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Student-Master"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "students" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("students");
                    setNewPath("students");
                    setShowSideOverlay(false);
                  }}
                >
                  <i className="fa-duotone fa-solid fa-graduation-cap"></i>
                  Students
                </button>
              ) : (
                ""
              )}

              {user.userType === "admin" ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "users" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("users");
                    setNewPath("users");
                    setShowSideOverlay(false);
                  }}
                >
                  <GroupIcon />
                  Users
                </button>
              ) : (
                ""
              )}

              {user.userType === "admin" || user.permissions.some(
                (data) => data.value === "Automation-Monitor"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "automonitor" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("automonitor");
                    setNewPath("automonitor");
                    setShowSideOverlay(false);
                  }}
                >
                  <AutoAwesomeIcon />
                  Automation Monitor
                </button>
              ) : (
                ""
              )}

              {user.permissions.some(
                (data) => data.value === "Download-History"
              ) ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "downloadHistory" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("downloadHistory");
                    setNewPath("downloadHistory");
                    setShowSideOverlay(false);
                  }}
                >
                  <DatasetIcon />
                  Download History
                </button>
              ) : (
                ""
              )}
              {user.permissions.some((data) => data.value === "Settings") ? (
                <button
                  className={`leftMenueButtons w-100 d-flex align-items-center gap-1 ${pageViews === "settings" ? "active" : ""
                    }`}
                  onClick={(e) => {
                    setPageViews("settings");
                    setNewPath("settings");
                    setShowSideOverlay(false);
                  }}
                >
                  <SettingsIcon />
                  Settings
                </button>
              ) : (
                ""
              )}
              <button
                className={`leftMenueButtons logOutButton w-100 d-flex align-items-center gap-1`}
                onClick={(e) => {
                  logOut();
                }}
              >
                <PowerSettingsNewIcon />
                Log Out
              </button>
            </div>
          ) : (
            <SkeletonTheme highlightColor="#d8733934">
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
              <Skeleton height={35} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default PageBinder;
